import React from 'react';
import { cn } from './lib/utils';

/* Grid-spanning hairline for the settings form grid — parity with legacy
   `~co/common/form` Separator. `default` draws the hairline via inset
   box-shadow; `transparent` is spacing-only. Consecutive separators
   collapse via the `.ui-separator + .ui-separator` rule in global.css. */
export function Separator({ className, variant = 'default', ...props }) {
  return (
    <div
      {...props}
      data-variant={variant}
      className={cn(
        'ui-separator col-span-full h-px',
        variant === 'default' &&
          'shadow-[inset_0_var(--shadow-height)_0_var(--shadow-color)]',
        className,
      )}
    />
  );
}
